import Vue from "vue";
import * as Sentry from "@sentry/vue";
import router from "./../router";
import { CaptureConsole as CaptureConsoleIntegration } from "@sentry/integrations";
import { isDevMode } from "../system/helper";
import { i18n } from "@/app/vue-config/i18n";

Sentry.init({
  Vue,
  sendClientReports: false,
  allowUrls: [/(.*\.)?hotel-spider\.com.*/],
  ignoreErrors: [
    "HierarchyRequestError",
    "Cmprm",
    "Hotjar",
    // when local storage is disabled, browsers may throw exceptions
    "Local storage is not supported",
    "SecurityError: The operation is insecure.",
    "NavigationDuplicated",
    "NS_ERROR_FILE_CORRUPTED",
    "Non-Error exception captured",
    "Non-Error promise rejection captured",
    "QuotaExceededError",
    /can't redefine non-configurable property "userAgent"/,
    "Meta Pixel",
    /Can't find variable: fbq/,
    /not authorized to show the cookie banner/,
    "separated-price__currency"
  ],
  environment: process.env.NODE_ENV,
  dsn: "https://a073850e583042f5bd3d93e39a320fe8@sentry.io/1866565",
  release: "spider-booking@" + process.env.npm_package_version,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  logErrors: isDevMode(),
  integrations: [
    new Sentry.Replay({
      maskAllText: false,
      blockAllMedia: false,
    }),
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: [
        process.env.CRS_ENDPOINT,
        process.env.TRANSLATIONS_ENDPOINT,
      ],
    }),
    new CaptureConsoleIntegration({ levels: ["error"] }),
  ],
  tracesSampleRate: 0.1,
  beforeSend(event) {
    event.tags = event.tags || {};
    event.tags["hotelId"] = Vue.prototype.$hotelId;
    event.tags["locale"] = i18n.locale;
    return event;
  },
});
